
export default async function getHtmlWithImages(printContainer: Element) {

    const images: NodeListOf<HTMLImageElement> = printContainer.querySelectorAll('img');

    await Promise.all(
        _.map(images, async (image: HTMLImageElement) => {

            const imageUrl = new URL(image.src);

            image.src = "https://goodday.work"+imageUrl.pathname
        })
    )

    return printContainer;
}
